export default {
    clientId: '7Vj1961f1qNoIZAt0w9gNCXBaEnCo3Eq',
    domain: 'dietary-profile.auth0.com',
};
